import { render, staticRenderFns } from "./MediaCategoryList.vue?vue&type=template&id=042269c4"
import script from "./MediaCategoryList.vue?vue&type=script&lang=js"
export * from "./MediaCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports